var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Reference: https://github.com/alibaba/formily/blob/formily_next/packages/antd/src/array-table/index.tsx
import { Box,
// Table, TableProps, Tbody, Td, Th, Thead, Tr
 } from '@chakra-ui/react';
import { Table } from '@forest/simple-ui';
import { observer, RecursionField, useField, useFieldSchema } from '@formily/react';
import { isArr } from '@formily/shared';
import React, { createContext, Fragment, useContext, useEffect, useRef, useState } from 'react';
import { ArrayBase } from '../ArrayBase';
// const SortableRow = SortableElement((props: any) => <tr {...props} />);
// const SortableBody = SortableContainer((props: any) => <tbody {...props} />);
const isColumnComponent = (schema) => {
    var _a;
    return ((_a = schema['x-component']) === null || _a === void 0 ? void 0 : _a.indexOf('Column')) > -1;
};
const isOperationsComponent = (schema) => {
    var _a;
    return ((_a = schema['x-component']) === null || _a === void 0 ? void 0 : _a.indexOf('Operations')) > -1;
};
const isAdditionComponent = (schema) => {
    var _a;
    return ((_a = schema['x-component']) === null || _a === void 0 ? void 0 : _a.indexOf('Addition')) > -1;
};
const useArrayTableSources = () => {
    const arrayField = useField();
    const schema = useFieldSchema();
    const parseSources = (schema) => {
        var _a, _b, _c;
        if (isColumnComponent(schema) || isOperationsComponent(schema) || isAdditionComponent(schema)) {
            if (!((_a = schema['x-component-props']) === null || _a === void 0 ? void 0 : _a['dataIndex']) && !schema['name'])
                return [];
            const name = ((_b = schema['x-component-props']) === null || _b === void 0 ? void 0 : _b['dataIndex']) || schema['name'];
            const field = arrayField.query(arrayField.address.concat(name)).take();
            const columnProps = ((_c = field === null || field === void 0 ? void 0 : field.component) === null || _c === void 0 ? void 0 : _c[1]) || schema['x-component-props'] || {};
            const display = (field === null || field === void 0 ? void 0 : field.display) || schema['x-display'];
            return [
                {
                    name,
                    display,
                    field,
                    schema,
                    columnProps,
                },
            ];
        }
        else if (schema.properties) {
            return schema.reduceProperties((buf, schema) => {
                return buf.concat(parseSources(schema));
            }, []);
        }
        return [];
    };
    const parseArrayItems = (schema) => {
        if (!schema)
            return [];
        const sources = [];
        const items = isArr(schema) ? schema : [schema];
        return items.reduce((columns, schema) => {
            const item = parseSources(schema);
            if (item) {
                return columns.concat(item);
            }
            return columns;
        }, sources);
    };
    if (!schema)
        throw new Error('can not found schema object');
    return parseArrayItems(schema.items);
};
const useArrayTableColumns = (field, sources) => {
    return sources.reduce((buf, { name, columnProps, schema, display }) => {
        if (display !== 'visible')
            return buf;
        if (!isColumnComponent(schema))
            return buf;
        // console.log('useArrayTableColumns', sources);
        return buf.concat(Object.assign(Object.assign({}, columnProps), { accessor: name, Cell: ({ row }) => {
                const { index } = row;
                return (_jsx(ArrayBase.Item, Object.assign({ index: index, record: () => { var _a; return (_a = field === null || field === void 0 ? void 0 : field.value) === null || _a === void 0 ? void 0 : _a[index]; } }, { children: _jsx(RecursionField, { schema: schema, name: index, onlyRenderProperties: true }) })));
            } }));
    }, []);
};
const useAddition = () => {
    const schema = useFieldSchema();
    return schema.reduceProperties((addition, schema, key) => {
        if (isAdditionComponent(schema)) {
            return _jsx(RecursionField, { schema: schema, name: key });
        }
        return addition;
    }, null);
};
// const schedulerRequest = {
//   request: null,
// };
// const StatusSelect: ReactFC<IStatusSelectProps> = observer(
//   (props) => {
//     const field = useField<ArrayField>();
//     const prefixCls = usePrefixCls('formily-array-table');
//     const errors = field.errors;
//     const parseIndex = (address: string) => {
//       return Number(
//         address
//           .slice(address.indexOf(field.address.toString()) + 1)
//           .match(/(\d+)/)?.[1]
//       );
//     };
//     const options = props.options?.map(({ label, value }) => {
//       const val = Number(value);
//       const hasError = errors.some(({ address }) => {
//         const currentIndex = parseIndex(address);
//         const startIndex = (val - 1) * props.pageSize;
//         const endIndex = val * props.pageSize;
//         return currentIndex >= startIndex && currentIndex <= endIndex;
//       });
//       return {
//         label: hasError ? <Badge dot>{label}</Badge> : label,
//         value,
//       };
//     });
//     const width = String(options?.length).length * 15;
//     return (
//       <Select
//         value={props.value}
//         onChange={props.onChange}
//         options={options}
//         virtual
//         style={{
//           width: width < 60 ? 60 : width,
//         }}
//         className={cls(`${prefixCls}-status-select`, {
//           'has-error': errors?.length,
//         })}
//       />
//     );
//   },
//   {
//     scheduler: (update) => {
//       clearTimeout(schedulerRequest.request);
//       schedulerRequest.request = setTimeout(() => {
//         update();
//       }, 100);
//     },
//   }
// );
const PaginationContext = createContext({});
const usePagination = () => {
    return useContext(PaginationContext);
};
const ArrayTablePagination = (props) => {
    var _a;
    const [current, setCurrent] = useState(1);
    // const prefixCls = usePrefixCls('formily-array-table');
    const pageSize = props.pageSize || 10;
    // const size = props.size || 'default';
    const dataSource = props.dataSource || [];
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize - 1;
    const total = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) || 0;
    const totalPage = Math.ceil(total / pageSize);
    // const pages = Array.from(new Array(totalPage)).map((_, index) => {
    //   const page = index + 1;
    //   return {
    //     label: page,
    //     value: page,
    //   };
    // });
    const handleChange = (current) => {
        setCurrent(current);
    };
    useEffect(() => {
        if (totalPage > 0 && totalPage < current) {
            handleChange(totalPage);
        }
    }, [totalPage, current]);
    const renderPagination = () => {
        if (totalPage <= 1)
            return;
        return (_jsx(Box, {}));
    };
    return (_jsx(Fragment, { children: _jsx(PaginationContext.Provider, Object.assign({ value: { totalPage, pageSize, changePage: handleChange } }, { children: (_a = props.children) === null || _a === void 0 ? void 0 : _a.call(props, dataSource === null || dataSource === void 0 ? void 0 : dataSource.slice(startIndex, endIndex + 1), renderPagination()) })) }));
};
// const RowComp = (props: any) => {
//   return <Tr index={props['data-row-key'] || 0} {...props} />;
// };
export const ArrayTable = observer((props) => {
    const ref = useRef(null);
    const field = useField();
    const dataSource = Array.isArray(field.value) ? field.value.slice() : [];
    const sources = useArrayTableSources();
    const columns = useArrayTableColumns(field, sources);
    // const pagination = isBool(props.pagination) ? {} : props.pagination;
    const { pagination = {} } = props, extraProps = __rest(props, ["pagination"]);
    const addition = useAddition();
    // const defaultRowKey = (record: any) => {
    //   return dataSource.indexOf(record);
    // };
    // const addTdStyles = (node: HTMLElement) => {
    //   // const helper = document.body.querySelector(`.${prefixCls}-sort-helper`);
    //   if (helper) {
    //     const tds = node.querySelectorAll('td');
    //     requestAnimationFrame(() => {
    //       helper.querySelectorAll('td').forEach((td, index) => {
    //         if (tds[index]) {
    //           td.style.width = getComputedStyle(tds[index]).width;
    //         }
    //       });
    //     });
    //   }
    // };
    // const WrapperComp = useCallback(
    //   (props: any) => (
    //     <Tbody
    //       useDragHandle
    //       lockAxis="y"
    //       helperClass={`${prefixCls}-sort-helper`}
    //       helperContainer={() => {
    //         return ref.current?.querySelector('tbody');
    //       }}
    //       onSortStart={({ node }) => {
    //         addTdStyles(node as HTMLElement);
    //       }}
    //       onSortEnd={({ oldIndex, newIndex }) => {
    //         field.move(oldIndex, newIndex);
    //       }}
    //       {...props}
    //     />
    //   ),
    //   []
    // );
    return (_jsx(ArrayTablePagination, Object.assign({}, pagination, { dataSource: dataSource }, { children: (dataSource) => (_jsx(Box, Object.assign({ ref: ref }, { children: _jsxs(ArrayBase, { children: [_jsx(Table, Object.assign({ tdLayout: "terse" }, extraProps, { data: dataSource, columns: columns })), sources.map((column, key) => {
                        //专门用来承接对Column的状态管理
                        if (!isColumnComponent(column.schema))
                            return _jsx(_Fragment, {});
                        return React.createElement(RecursionField, {
                            name: column.name,
                            schema: column.schema,
                            onlyRenderSelf: true,
                            key,
                        });
                    }), addition] }) }))) })));
});
ArrayTable.displayName = 'ArrayTable';
ArrayTable.Column = () => {
    return _jsx(Fragment, {});
};
ArrayBase.mixin(ArrayTable);
const Addition = (props) => {
    // const array = ArrayBase.useArray();
    usePagination();
    return (_jsx(ArrayBase.Addition, Object.assign({ w: "100%", mt: "4" }, props, { onClick: (e) => {
            var _a;
            // 如果添加数据后将超过当前页，则自动切换到下一页
            // const total = array?.field?.value.length || 0;
            // if (total === totalPage * pageSize + 1 && isFn(changePage)) {
            //   changePage(totalPage + 1);
            // }
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } })));
};
ArrayTable.Addition = Addition;
export default ArrayTable;
